import { Helmet } from "react-helmet";
import { claimStageCopy } from "./claimTitles";

// The single title owner for the active claim screen. react-helmet restores
// the previous document title when this unmounts.
export default function ClaimHead({ stage, reason }) {
  const { title } = claimStageCopy(stage, { reason });
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}

export function useClaimHeading(stage, reason) {
  return claimStageCopy(stage, { reason }).heading;
}
